// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".standards-picker-card.v-card.v-sheet > .v-card__text[style] {\n  max-height: none !important;\n  overflow: visible !important;\n}\n.appended-button {\n  margin-left: -8px;\n  position: relative;\n  margin-top: -8px;\n}", ""]);
// Exports
module.exports = exports;
